import { gql } from '@apollo/client';

const GENERATE_HOLTER_REPORT_MUTATION = gql`
  mutation generateHolterReport($input: GenerateHolterReportInput!) {
    generateHolterReport(input: $input) {
      isSuccess
      message
      isReady
      processingStudyFids
      simultaneousStudyLimit
    }
  }
`;

export default GENERATE_HOLTER_REPORT_MUTATION;
